import { render } from "./TournamentResultList.vue?vue&type=template&id=07239bfe&scoped=true"
import script from "./TournamentResultList.vue?vue&type=script&lang=js"
export * from "./TournamentResultList.vue?vue&type=script&lang=js"

import "./TournamentResultList.vue?vue&type=style&index=0&id=07239bfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07239bfe"]])

export default __exports__